module.exports = __webpack_public_path__ + "static/img/gift.6f0ff9df.png";